import React from 'react';

// Define separate props for button and anchor
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement>;
type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

type CommonProps = {
  children: React.ReactNode;
  className?: string;
  disabled: boolean;
};
interface ButtonOrLinkProps extends CommonProps {
  linkValue: string | null;
  buttonProps?: Omit<ButtonProps, keyof CommonProps>;
  anchorProps?: Omit<AnchorProps, keyof CommonProps>;
  onClick?: (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => void;
}

export const ButtonOrLinkComponent: React.FC<ButtonOrLinkProps> = ({
  linkValue,
  children,
  className,
  buttonProps,
  anchorProps,
  ...commonProps
}) => {
  if (linkValue) {
    return (
      <a
        href={linkValue}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        {...anchorProps}
        {...commonProps}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={className}
      {...buttonProps}
      {...commonProps}
    >
      {children}
    </button>
  );
};
